import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useAddClientDeposit = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["add_deposit"],
    mutationFn: async (query) => {
      return await axios.post("/settlement/deposit", query);
    },
  });
};